import  { useEffect, useMemo, useState, useContext, useRef, startTransition } from "react";
import { CloseOutlined, QrcodeOutlined } from "@ant-design/icons";
import { Modal } from "@mui/material";
import MainBtn from "../../main/main_btn/MainBtn";
import { App, Input, Select, Tabs, Steps, Alert } from "antd";
import { Home } from "../../../lib/Home";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../../store/dispatcher";
import { DispatchProps, StateProps } from "../../../store";
import { Device } from "../../../lib/Device";
import { useTranslation } from "react-i18next";
import axios from "../../../services/axios";
import { runes } from 'runes2';
import AuthContext from "../../../contexts/AuthContext";
import QRScannerComponent from "../../common/QRScanner";
import WiFiConfigurationSteps from "../../common/WiFiConfigurationSteps";
import ParameterConfigurationPicker from "../../device/ParameterConfigurationPicker";
import {
  ParameterConfigurationOption,
  getDefaultConfigId,
} from "../../../lib/parameterConfiguration";

const empty_schedule = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
];

const CreateDeviceModal = ({
  open = false,
  close = () => null,
  device,
  homes,
  devices,
  createDevice,
  updateDevice,
}: {
  open: boolean;
  close: () => void;
  device: number;
  homes: Home[];
  devices: Device[];
  createDevice: any;
  updateDevice: any;
}) => {
  const { t } = useTranslation("home");
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [qrScannerOpen, setQrScannerOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    home: 0,
    device_id: "",
    device_secret: "",
    name: "",
  });
  const [createdDevice, setCreatedDevice] = useState<Device | null>(null);
  const [parameterConfigs, setParameterConfigs] = useState<ParameterConfigurationOption[]>([]);
  const [selectedConfigId, setSelectedConfigId] = useState<number | null>(null);
  const connectionTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { notification } = App.useApp();

  // Check if user is installer
  const isInstaller = user.is_installer;

  const handleQRScan = (data: { device_id: string; secret: string }) => {
    console.log('QR Scan data received:', data);
    setFormData(prev => {
      const newData = {
        ...prev,
        device_id: data.device_id,
        device_secret: data.secret,
        name: data.device_id,
      };
      return newData;
    });
    setQrScannerOpen(false);
  };

  const create_device = async () => {
    setLoading(true);
    let error: any | null = null;
    
    const requestData: any = {
      name: formData.name,
      home: formData.home,
      device_id: formData.device_id,
      schedule: [...empty_schedule],
    };

    if (!isInstaller) {
      requestData.secret = formData.device_secret;
    }

    const response = await axios
      .post(`/api-v1/device/`, requestData)
      .then((e) => e.data)
      .catch((e) => {
        error = e.response?.data || e.message;
        console.error('Device creation error:', error);
        return null;
      });
    if (response) {
      setCreatedDevice(response);
      createDevice(response);
      setCurrentStep(1);
      const model = response.soliseco_model;
      if (model) {
        axios
          .get(`/api-v1/config/parameter-configurations/?soliseco_model=${encodeURIComponent(model)}`)
          .then((res) => {
            const configs = res.data as ParameterConfigurationOption[];
            setParameterConfigs(configs);
            setSelectedConfigId(
              getDefaultConfigId(configs, model, response.parameter_configuration?.id)
            );
          })
          .catch(() => {
            setParameterConfigs([]);
          });
      }
    } else {
      if (error?.["device_id"]) {
        notification.error({
          message: t("messages:create_home_error_message"),
          description: t("messages:create_home_error_bad_id"),
          placement: "topLeft",
        });
      } else if (error?.["secret"]) {
        notification.error({
          message: t("messages:create_home_error_message"),
          description: t("messages:create_home_error_bad_secret"),
          placement: "topLeft",
        });
      } else {
        notification.error({
          message: t("wizard_device_creation_error"),
          description: error?.message || t("wizard_device_creation_error_description"),
          placement: "topLeft",
        });
      }
    }
    setLoading(false);
  };

  const handleNext = () => {
    if (currentStep === 0) {
      if (
        formData.device_id === "" ||
        formData.name === "" ||
        device_exist !== null ||
        (!isInstaller && formData.device_secret === "")
      ) {
        return;
      }
      create_device();
    } else if (currentStep === 1) {
      startTransition(() => {
        setCurrentStep(2);
      });
    } else if (currentStep === 2) {
      startTransition(() => {
        setCurrentStep(3);
      });
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      startTransition(() => {
        setCurrentStep(currentStep - 1);
      });
    }
  };

  const handleFinish = async () => {
    if (!createdDevice || selectedConfigId == null) {
      close();
      return;
    }
    setLoading(true);
    try {
      const response = await axios.patch(`/api-v1/device/${createdDevice.id}/`, {
        parameter_configuration: selectedConfigId,
        apply_default_values: true,
      });
      updateDevice({
        id: createdDevice.id,
        data: response.data,
        updated: true,
      });
      close();
    } catch (error: any) {
      notification.error({
        message: t("wizard_config_save_error"),
        description:
          error.response?.data?.parameter_configuration?.[0] ||
          error.response?.data?.parameter_configuration ||
          t("wizard_config_save_error_description"),
        placement: "topLeft",
      });
    }
    setLoading(false);
  };

  const device_exist = useMemo(() => {
    if (!devices || !devices.length) return null;
    const exist = devices.filter(
      (device) =>
        device.name === formData.name || device.device_id === formData.device_id
    );
    if (exist.length) return exist[0];
    return null;
  }, [devices, formData]);

  useEffect(() => {
    if (open) {
      setFormData({
        home: device > 0 ? device : homes[0]?.id || 0,
        device_id: "",
        device_secret: "",
        name: "",
      });
      setCurrentStep(0);
      setCreatedDevice(null);
      setParameterConfigs([]);
      setSelectedConfigId(null);
      if (connectionTimeoutRef.current) {
        clearTimeout(connectionTimeoutRef.current);
      }
    }
    
    return () => {
      if (connectionTimeoutRef.current) {
        clearTimeout(connectionTimeoutRef.current);
      }
    };
  }, [open, device, homes]);


  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <div>
            <Tabs
              defaultActiveKey="manual"
              items={[
                {
                  key: 'manual',
                  label: t('manual_entry'),
                  children: (
                    <div>
                      <form className="classic-form">
                        <div className="input-block">
                          <label htmlFor="country-selector">{t("home_label")}</label>
                          <Select
                            id="country-selector"
                            value={formData.home}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                home: e,
                              })
                            }
                          >
                            {homes?.map((home: Home, key: number) => (
                              <Select.Option key={key} value={home.id}>
                                {home.name} {home.user_email && `(${home.user_first_name} ${home.user_last_name})`}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                        <div className="input-block">
                          <label htmlFor="device-id-input">{t("device_id_label")}</label>
                          <Input
                            size="small"
                            value={formData.device_id}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                device_id: e.target.value,
                              })
                            }
                            status={
                              device_exist && device_exist.device_id === formData.device_id
                                ? "error"
                                : ""
                            }
                            placeholder={t("device_id_placeholder")}
                            type="text"
                            autoComplete="given-name"
                            id="device-id-input"
                          />
                        </div>
                        {!isInstaller && (
                          <div className="input-block">
                            <label htmlFor="device-secret-input">
                              {t("device_secret_label")}
                            </label>
                            <Input
                              size="small"
                              value={formData.device_secret}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  device_secret: e.target.value,
                                })
                              }
                              placeholder={t("device_secret_placeholder")}
                              type="text"
                              autoComplete="given-name"
                              id="device-secret-input"
                            />
                          </div>
                        )}
                        <div className="input-block">
                          <label htmlFor="device-name-input">
                            {t("device_name_label")}
                          </label>
                          <Input
                            size="small"
                            value={formData.name}
                            status={
                              device_exist && device_exist.name === formData.name
                                ? "error"
                                : ""
                            }
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                name: e.target.value,
                              })
                            }
                            count={{
                              show: true,
                              max: 25,
                              strategy: (txt) => runes(txt).length,
                              exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join(''),
                            }}
                            placeholder={t("device_name_placeholder")}
                            type="text"
                            autoComplete="given-name"
                            id="device-name-input"
                          />
                        </div>
                      </form>
                    </div>
                  ),
                },
                {
                  key: 'qr',
                  label: t('scan_qr_code'),
                  children: (
                    <div style={{ textAlign: 'center', padding: '20px 0' }}>
                      <QrcodeOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: 16 }} />
                      <p style={{ marginBottom: 16 }}>{t('qr_scanner_description')}</p>
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <MainBtn
                          title={t('qr_scanner_start_scanning')}
                          icon={<QrcodeOutlined />}
                          onClick={() => setQrScannerOpen(true)}
                          color="primary"
                        />
                      </div>
                    </div>
                  ),
                },
              ]}
            />
          </div>
        );
      case 1:
        return (
          <WiFiConfigurationSteps
            currentStep={0}
            hideInternalSteps={true}
          />
        );
      case 2:
        return (
          <WiFiConfigurationSteps
            currentStep={1}
            hideInternalSteps={true}
          />
        );
      case 3:
        return (
          <div>
            <p style={{ marginBottom: 16 }}>{t("wizard_config_step_help")}</p>
            <ParameterConfigurationPicker
              configs={parameterConfigs}
              solisecoModel={createdDevice?.soliseco_model}
              currentConfigId={createdDevice?.parameter_configuration?.id}
              value={selectedConfigId}
              onChange={setSelectedConfigId}
            />
          </div>
        );
      default:
        return null;
    }
  };

  const steps = [
    {
      title: t("wizard_step_1_title"),
      description: t("wizard_step_1_description"),
    },
    {
      title: t("wizard_step_2_title"),
      description: t("wizard_step_2_description"),
    },
    {
      title: t("wizard_step_3_title"),
      description: t("wizard_step_3_description"),
    },
    {
      title: t("wizard_step_4_title"),
      description: t("wizard_step_4_description"),
    },
  ];

  return (
    <>
      <Modal className="soliseco-modal" open={open} onClose={close}>
        <div className="modal-center">
          <div className="modal-header">
            <div className="close-container" onClick={close}>
              <CloseOutlined />
            </div>
            <span className="title">
              {isInstaller ? t("add_device_modal_title_installer") : t("new_device_modal_title")}
            </span>
            <p>
              {isInstaller ? t("add_device_modal_description_installer") : t("new_device_modal_description")}
            </p>
          </div>
          <div className="modal-content">
            <Steps current={currentStep} items={steps} style={{ marginBottom: '32px' }} />
            {renderStepContent()}
          </div>
          <div className="modal-footer">
            {currentStep > 0 && (
              <MainBtn
                title={t("wizard_back_btn")}
                color="secondary"
                onClick={handleBack}
                disabled={loading}
              />
            )}
            {currentStep < 3 ? (
              <MainBtn
                title={t("wizard_next_btn")}
                loading={loading}
                onClick={handleNext}
                disabled={
                  currentStep === 0 &&
                  (formData.device_id === "" ||
                    formData.name === "" ||
                    device_exist !== null ||
                    (!isInstaller && formData.device_secret === ""))
                }
              />
            ) : (
              <MainBtn
                title={t("wizard_finish_btn")}
                loading={loading}
                onClick={handleFinish}
                disabled={selectedConfigId == null}
              />
            )}
            {currentStep === 0 && (
              <MainBtn title={t("main:cancel")} color="secondary" onClick={close} />
            )}
          </div>
        </div>
      </Modal>
      
      <QRScannerComponent
        open={qrScannerOpen}
        onClose={() => setQrScannerOpen(false)}
        onScan={handleQRScan}
      />
    </>
  );
};

export default connect<StateProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(CreateDeviceModal);
